export enum Status {
  SUCCESS = 'SUCCESS',
  SUCCESS_COMPLETE = 'SUCCESS_COMPLETE',
  WARNING = 'WARNING',
  PROGRESS = 'PROGRESS',
  ERROR = 'ERROR',
  OPEN = 'OPEN',
  UNSIGNED = 'UNSIGNED',
  UNSIGNED_NO_PERMISSION = 'UNSIGNED_NO_PERMISSION',
  PARTIALLY_SIGNED = 'PARTIALLY_SIGNED',
  PARTIALLY_SIGNED_NO_PERMISSION = 'PARTIALLY_SIGNED_NO_PERMISSION',
  FULLY_SIGNED = 'FULLY_SIGNED',
  MISSING_SIGNATURE_RULE = 'SIGNATURE_RULE_MISSING',
  IMPORTED = 'IMPORTED',
  IMPORT_ERROR = 'IMPORT_ERROR',
  UPLOAD_ERROR = 'UPLOAD_ERROR',
  CONVERSION_ERROR = 'CONVERSION_ERROR',
  TEMPLATE_SANITIZATION_ERROR = 'TEMPLATE_SANITIZATION_ERROR',
}
